module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("Table of Contents.")]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main_0004#CHAPTER_I",
      "id": "TOC_1"
    }
  }, [_vm._v("CHAPTER I.")]), _c('br'), _vm._v("\n  Mrs. Hardy’s Resolution.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main_0004#CHAPTER_II",
      "id": "TOC_2"
    }
  }, [_vm._v("CHAPTER II.")]), _c('br'), _vm._v("\n  The Start.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main1.htm#CHAPTER_III",
      "id": "TOC_3"
    }
  }, [_vm._v("CHAPTER III.")]), _c('br'), _vm._v("\n  A New Life.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main1.htm#CHAPTER_IV",
      "id": "TOC_4"
    }
  }, [_vm._v("CHAPTER IV.")]), _c('br'), _vm._v("\n  The Pampas.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main1.htm#CHAPTER_V",
      "id": "TOC_5"
    }
  }, [_vm._v("CHAPTER V.")]), _c('br'), _vm._v("\n  The Settler’s Home.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00009"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main2.htm#CHAPTER_VI",
      "id": "TOC_6"
    }
  }, [_vm._v("CHAPTER VI.")]), _c('br'), _vm._v("\n  A Tale of the Mexican War.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main2.htm#CHAPTER_VII",
      "id": "TOC_7"
    }
  }, [_vm._v("CHAPTER VII.")]), _c('br'), _vm._v("\n  Seth Continues His Narrative of the Mexican Adventure.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00011"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main3.htm#CHAPTER_VIII",
      "id": "TOC_8"
    }
  }, [_vm._v("CHAPTER VIII.")]), _c('br'), _vm._v("\n  Farm Work and Amusements.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00012"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main3.htm#CHAPTER_IX",
      "id": "TOC_9"
    }
  }, [_vm._v("CHAPTER IX.")]), _c('br'), _vm._v("\n  Neighbourly Visits and Advice.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00013"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main4.htm#CHAPTER_X",
      "id": "TOC_10"
    }
  }, [_vm._v("CHAPTER X.")]), _c('br'), _vm._v("\n  The Lost Cattle.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00014"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main5.htm#CHAPTER_XI",
      "id": "TOC_11"
    }
  }, [_vm._v("CHAPTER XI.")]), _c('br'), _vm._v("\n  Quiet Times.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00015"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main5.htm#CHAPTER_XII",
      "id": "TOC_12"
    }
  }, [_vm._v("CHAPTER XII.")]), _c('br'), _vm._v("\n  A Steady Hand.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00016"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main6.htm#CHAPTER_XIII",
      "id": "TOC_13"
    }
  }, [_vm._v("CHAPTER XIII.")]), _c('br'), _vm._v("\n  The Indian Attack.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00017"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main6.htm#CHAPTER_XIV",
      "id": "TOC_14"
    }
  }, [_vm._v("CHAPTER XIV.")]), _c('br'), _vm._v("\n  Terrible News.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00018"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main7.htm#CHAPTER_XV",
      "id": "TOC_15"
    }
  }, [_vm._v("CHAPTER XV.")]), _c('br'), _vm._v("\n  The Pampas on Fire.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00019"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main7.htm#CHAPTER_XVI",
      "id": "TOC_16"
    }
  }, [_vm._v("CHAPTER XVI.")]), _c('br'), _vm._v("\n  At the Stake.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00020"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main8.htm#CHAPTER_XVII",
      "id": "TOC_17"
    }
  }, [_vm._v("CHAPTER XVII.")]), _c('br'), _vm._v("\n  Rescued.")]), _vm._v(" "), _c('h4', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00021"
    }
  }, [_c('a', {
    staticClass: "c3 pginternal",
    attrs: {
      "href": "#/Text/main9.htm#CHAPTER_XVIII",
      "id": "TOC_18"
    }
  }, [_vm._v("CHAPTER XVIII.")]), _c('br'), _vm._v("\n  And Last.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f1ba10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/main_0002.vue
// module id = 63
// module chunks = 0